export class UserDashboardItemResultDto {
    module: string;
    workArea: string;
    helpKey: string;
    status: 'PRIORITY' | 'PROBLEMATIC' | 'INFO' | 'OK';
    open: number;
    priority: number;
    problematic: number;

    get actualOpen(): number {
        return Math.max(0, this.open - this.priority - this.problematic);
    }

    get isOk(): boolean {
        return this.status === 'OK';
    }

    get isInfo(): boolean {
        return this.status === 'INFO';
    }

    get isPriority(): boolean {
        return this.status === 'PRIORITY';
    }

    get isProblematic(): boolean {
        return this.status === 'PROBLEMATIC';
    }

    get workAreaId(): string {
        return this.workArea.replace(/[^\w\s]/gi, '').replace(/ /gi, '');
    }
}
